<template>
<div class="counting-container">
    <Row type="flex">
        <Col flex="1">
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">修磨操作说明</div>
            <Row type="flex">
                <Col flex="1">
                <div>手动修磨操作流程：</div>
                <div>1，修磨前，点击屏幕“修磨/工作”按键，系统进入修磨模式；</div>
                <div>2，放好修磨片，按下启动装置（启动按键或脚踏开关），电极下行，开始修磨；</div>
                <div>3，待电极修磨完好后，再次按下启动装置（启动按键或脚踏开关），电极上行，取出修磨片。</div>
                <div>4，点击屏幕“修磨确认”按键，修磨结束。</div>
                <div>5，再次点击屏幕“修磨/工作”按键，系统退出修磨模式。</div>
                </Col>
                <Col flex="1">
                <div>自动修磨操作流程</div>
                <div>1，修磨前，点击屏幕“修磨/工作”按键，系统进入修磨模式；</div>
                <div>2，按下启动装置（启动按键或脚踏开关），系统开始自动修磨；</div>
                <div>3，待修磨完成后，点击屏幕“修磨确认”按键，修磨结束。</div>
                <div>4，再次点击屏幕“修磨/工作”按键，系统退出修磨模式。</div>
                </Col>
            </Row>

        </Card>
        </Col>
        <Col flex="1">
        <Card class="card-container" dis-hover>
            <div slot="title" class="card-title">修磨</div>

            <Row type="flex">
                <Col flex="1">
                修磨类型
                </Col>
                <Col flex="1">
                    {{ fixType }}
                </Col>
              
            </Row>
             <Row type="flex">
                <Col flex="1">
                修磨下行压力
                </Col>
                <Col flex="1">
{{ systemData. E1PrsDrs}}
                </Col>
              
            </Row>
             <Row type="flex">
                <Col flex="1">
                修磨上行压力
                </Col>
                <Col flex="1">

                </Col>
              
            </Row>
            <Row type="flex">
                <Col flex="1">
                修磨时间
                </Col>
                <Col flex="1">

                </Col>
              
            </Row>
            <Row type="flex">
                <Col flex="1">
                <Button type="primary" @click="normalControl('CmdMan1',14)" >修磨/工作</Button>
                </Col>
                <Col flex="1">
                <Button type="primary" @click="normalControl('CmdMan1',15)" >修磨确认</Button>
                </Col>
                
            </Row>

        </Card>

        </Col>
    </Row>

</div>
</template>

<script>
import axios from 'axios';
import {
    API_URL
} from '@/constants/const'
import {
    mapGetters
} from 'vuex'
import {
    postJsError,int16toBit
} from '@/util/util.js'
export default {
    name: 'CountPanel',
    props: {
        mac: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            loading: false,
            systemData: {},
            originalData: {},
        }
    },
    computed: {
        ...mapGetters(['getTranslation']),
        fixType(){
            let typeMap = [
                "手动",
                "自动"
            ];
            let CfgSysFunc1Bit = int16toBit(this.systemData.CfgSysFunc1);
            let bit = CfgSysFunc1Bit[12]
            return typeMap[bit]
        }

    },
    async created() {
        this.init();
    },
    methods: {
        async init() {
            const url = API_URL['501SystemGet'];
            let params = {
                mac: this.mac
            }
            let res = await axios.get(url, {
                    params: params
                })
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
            if (res && res.data && res.data.code == 200) {
                if (res.data.data.param) {
                    for (var i in res.data.data.param) {
                        this.$set(this.systemData, i, res.data.data.param[i])
                    }
                    // 保存原始值快照
                    this.originalData = JSON.parse(JSON.stringify(this.systemData))
                }
            } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }
        },
        async download(changed){
          const url = API_URL['501CommuDownload'];
            // 计算与原始值的差异，只发送变更的字段（nil 指针 = 不写入）
            
            
            let formData = new FormData();
            formData.append('mac', this.mac);
            formData.append('param', JSON.stringify(changed));
            let res = await axios.post(url, formData)
                .catch((err) => {
                    postJsError(err)
                    this.$Message.error(this.getTranslation('c001'));
                })
            if (res && res.data && res.data.code == 200) {
              // 写入成功，更新原始快照
              this.$Message.success(res.data.msg);
            } else if (res && res.data && res.data.msg) {
                this.$Message.error(res.data.msg);
            } else {
                this.$Message.error(this.getTranslation('c001'));
            }
        },   
        async normalControl(key,offset){
            const val = 1 << offset
            let changed = {}
            changed[key] = val
            await this.download(changed)
        }
    }
}
</script>

<style scoped>
@import url('../../../../assets/style/list.css');
@import url('../../../../assets/style/tab.css');

.counting-container {
    padding: 10px;
}
</style>
